import { useMatches } from "@tanstack/react-router";
import { useIsDesktop } from "@/hooks/use-is-desktop";

/**
 * Screens one level below a bottom-nav tab, as TanStack `fullPath` templates
 * (trailing slash included, as the router reports them). See
 * [[bottom-nav.spec]] § Nested screens.
 */
const NESTED_SCREENS: ReadonlySet<string> = new Set([
  "/projects/$projectId/reports/$reportId/",
  "/projects/$projectId/issues/$issueId/",
]);

/**
 * Whether the project layout leaves the bottom nav out: on a phone, on a
 * nested screen, whose own back arrow is then the way out. Desktop always keeps
 * the nav.
 *
 * The layout reads this once for both the nav and the space `<main>` reserves
 * for it, so the two cannot disagree ([[safe-area-bottom]]).
 */
export function useBottomNavHidden(): boolean {
  const matches = useMatches();
  const currentPath = matches[matches.length - 1]?.fullPath ?? "";
  const isDesktop = useIsDesktop();
  return !isDesktop && NESTED_SCREENS.has(currentPath);
}
